/* ===================================================== */
/* PRODUCT DATA */
/* ===================================================== */

const products = {

    scraper:{

        image:{
            desktop:window.detoxImages.heroScraper,
            mobile:window.detoxImages.mobileScraper
        },

        h1:"Pure Copper Tongue Scraper",

        h2:"Time-Tested. Research-Backed. Non-Negotiable.",

        description:"Pure antimicrobial copper helps sweep away overnight impurities, tongue coating, and odor-causing buildup in seconds."

    },

    brush:{

        image:{
            desktop:window.detoxImages.heroBrush,
            mobile:window.detoxImages.mobileBrush
        },

        h1:"Ionic Copper Dry Body Brush",

        h2:"The Full-Body Powerhouse.",

        description:"Our signature ionic copper bristles exfoliate, energize circulation, and support lymphatic movement. Trusted by leading luxury spas."

    },

    potion:{

        image:{
            desktop:window.detoxImages.heroPotion,
            mobile:window.detoxImages.mobilePotion
        },

        h1:"Immunity Potion",

        h2:"13 Plants. Serious Daily Support.",

        description:"USDA Certified Organic and vegan, with time-tested Ayurvedic botanicals for immunity, digestion, inflammation, and resilience."

    },

    cup:{

        image:{
            desktop:window.detoxImages.heroCup,
            mobile:window.detoxImages.mobileCup
        },

        h1:"Hammered Pure Copper Tumbler",

        h2:"The Ancient Ritual of Copper Water.",

        description:"Uncoated and unlacquered for authentic copper-stored water. Naturally antimicrobial, traditionally used for purification, and made from an essential mineral."

    }

};


/* ===================================================== */
/* DEFAULT CONTENT */
/* ===================================================== */

const defaultContent = {

    image:{
        desktop:window.detoxImages.heroDefault,
        mobile:window.detoxImages.mobileDefault
    },

    h1:"Everything You Need For A Daily Detox Ritual",

    h2:"",

    description:"Begin your morning with a simple Ayurvedic-inspired ritual designed to support daily wellness and mindful living."

};


/* ===================================================== */
/* PRELOAD IMAGES */
/* ===================================================== */

[
    window.detoxImages.heroDefault,
    window.detoxImages.heroScraper,
    window.detoxImages.heroBrush,
    window.detoxImages.heroPotion,
    window.detoxImages.heroCup,

    window.detoxImages.mobileDefault,
    window.detoxImages.mobileScraper,
    window.detoxImages.mobileBrush,
    window.detoxImages.mobilePotion,
    window.detoxImages.mobileCup

].forEach(src => {

    const img = new Image();
    img.src = src;

});


/* ===================================================== */
/* ELEMENTS */
/* ===================================================== */

const heroImage = document.getElementById("heroImage");
const cardTitle = document.getElementById("cardTitle");
const cardDescription = document.getElementById("cardDescription");
const cardBenefits = document.getElementById("cardBenefits");
const hotspots = document.querySelectorAll(".hotspot");


/* ===================================================== */
/* HELPERS */
/* ===================================================== */

function isMobile() {

    return window.innerWidth <= 768;

}


function getImage(data) {

    return isMobile()
        ? data.image.mobile
        : data.image.desktop;

}


/* ===================================================== */
/* UPDATE CONTENT */
/* ===================================================== */

function updateContent(data){

    if(!heroImage) return;


    /* Fade out */

    cardTitle.style.opacity = 0;
    cardDescription.style.opacity = 0;
    cardBenefits.style.opacity = 0;


    setTimeout(()=>{


        /* ----------------------------------------- */
        /* IMAGE */
        /* ----------------------------------------- */

        heroImage.src = getImage(data);


        /* ----------------------------------------- */
        /* H1 + H2 */
        /* ----------------------------------------- */

        cardTitle.innerHTML = "";


        const h1 = document.createElement("h1");

        h1.textContent = data.h1;


        cardTitle.appendChild(h1);


        if(data.h2){

            const h2 = document.createElement("h2");

            h2.textContent = data.h2;

            cardTitle.appendChild(h2);

        }


        /* ----------------------------------------- */
        /* PARAGRAPH */
        /* ----------------------------------------- */

        cardDescription.innerHTML = "";

        const p = document.createElement("p");

        p.textContent = data.description;

        cardDescription.appendChild(p);


        /* ----------------------------------------- */
        /* REMOVE OLD BENEFITS */
        /* ----------------------------------------- */

        cardBenefits.innerHTML = "";


        /* ----------------------------------------- */
        /* FADE IN */
        /* ----------------------------------------- */

        heroImage.style.opacity = 1;

        cardTitle.style.opacity = 1;

        cardDescription.style.opacity = 1;

        cardBenefits.style.opacity = 1;


    },180);

}


/* ===================================================== */
/* INITIAL LOAD */
/* ===================================================== */

updateContent(defaultContent);


/* ===================================================== */
/* HOTSPOTS */
/* ===================================================== */

hotspots.forEach(hotspot=>{

    const product = hotspot.dataset.product;


    /* ----------------------------------------- */
    /* DESKTOP HOVER */
    /* ----------------------------------------- */

    hotspot.addEventListener("mouseenter",()=>{

        if(!isMobile()){

            updateContent(products[product]);

        }

    });


    /* ----------------------------------------- */
    /* DESKTOP MOUSE LEAVE */
    /* ----------------------------------------- */

    hotspot.addEventListener("mouseleave",()=>{

        if(!isMobile()){

            updateContent(defaultContent);

        }

    });


    /* ----------------------------------------- */
    /* MOBILE CLICK */
    /* ----------------------------------------- */

    hotspot.addEventListener("click",()=>{

        if(isMobile()){

            updateContent(products[product]);

        }

    });

});


/* ===================================================== */
/* WINDOW RESIZE */
/* ===================================================== */

window.addEventListener("resize",()=>{

    updateContent(defaultContent);

});


/* ===================================================== */
/* MOBILE: RESET TO DEFAULT WHEN CLICKING OUTSIDE HOTSPOTS */
/* ===================================================== */

document.addEventListener("click", (event) => {


    /* Desktop should behave exactly as it does now */

    if (!isMobile()) return;


    /* Clicking any hotspot should keep its product information */

    if (event.target.closest(".hotspot")) return;


    /* Anything else returns to the normal/default card */

    updateContent(defaultContent);

});